import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';

const ParentComplaintsDetailsLazy = React.lazy(
	() =>
		import(
			/* webpackChunkName : 'ParentComplaintsDetails' */ './components/ParentComplaintsDetails'
		)
);

export default (store) => {
	return {
		path: ':complaintId',
		element: <AsyncLoading component={<ParentComplaintsDetailsLazy />} />,
	};
};
